<template>
  <panel title="Paczki płatności">
    <w-table
      entity-type="paymentPack"
      :per-page="-1"
      :hide-add-button="true"
      :hide-search-input="true"
      :actions="actions"
      :columns="columns"
      :data="list"
      :total="count"
      @view="goToPayments"
    />
  </panel>
</template>

<script>
import Panel from '@/components/panel/Panel';
import WTable from '@/components/table/Table';
import { Errors } from '@/enums/errors.enum';
import { dateTime } from '@/filters/date';
import { listMixin } from '@/mixins/list';
import { VIEW_ACTION } from '@/utils/constants';

const messages = {
  listError: Errors.PAYMENT_PACK_CANNOT_LIST
};

// @vuese
// Lista paczek płatności
// @group Procedure
export default {
  components: { Panel, WTable },

  mixins: [listMixin('paymentPack', messages)],

  data() {
    return {
      actions: [{ ...VIEW_ACTION, permissions: ['PAYMENT.LIST'] }],
      columns: [
        { name: 'id', displayName: 'ID', sortable: true },
        { name: 'number', displayName: 'Numer', sortable: true },
        { name: 'created', displayName: 'Data utworzenia', nameTransformer: value => dateTime(value), sortable: true },
        { name: 'externalId', displayName: 'Identyfikator KSAT', sortable: true },
        { name: 'structureNode.name', displayName: 'Jednostka', nameTransformer: value => value || 'OW' }
      ]
    };
  },

  methods: {
    // @vuese
    // Przechodzi do listy płatności danej paczki
    goToPayments(pack) {
      this.$router.push({ name: 'procedurePayments', params: { packId: pack.id } });
    }
  }
};
</script>
